import { Card } from "@/components/ui/card";

interface Recommendation {
  title: string;
  description: string;
  priority: 'High' | 'Medium' | 'Low';
}

interface RecommendationSectionProps {
  recommendations: Recommendation[];
}

export const RecommendationSection = ({ recommendations }: RecommendationSectionProps) => {
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return 'bg-red-100 text-red-700 border-red-200';
      case 'Medium':
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
      case 'Low':
        return 'bg-green-100 text-green-700 border-green-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  };

  return (
    <div className="space-y-6">
      {recommendations.map((rec, index) => (
        <div 
          key={index} 
          className="p-6 rounded-xl bg-white/50 backdrop-blur-sm border border-opacity-50 hover:shadow-md transition-all duration-300"
        >
          <div className="flex justify-between items-start mb-3">
            <h3 className="font-semibold text-lg">{rec.title}</h3>
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getPriorityColor(rec.priority)}`}>
              {rec.priority}
            </span>
          </div>
          <p className="text-muted-foreground leading-relaxed">{rec.description}</p>
        </div>
      ))}
    </div>
  );
};